import { useCallback } from "react";

export default function useNumber() {
  const currency = (
    number: string | number,
    locale: string = "en-IN",
    currency: string = "INR",
  ) => {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      maximumFractionDigits: Number.isInteger(Number(number)) ? 0 : 2,
    }).format(Number(number));
  };

  return {
    currency: useCallback(currency, []),
  };
}
